// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1WYa-","link":"Header_link__3dhc1","button":"Header_button__MLkU7","active-route":"Header_active-route__NPrrB"};